import React from "react";
import { SITE } from "../mock";

export const CornerLeaves = () => {
  return (
    <>
      <img src={SITE.leafTopLeft} alt="dekor list vlevo" className="corner-leaf top-left" />
      <img src={SITE.leafBottomRight} alt="dekor list vpravo" className="corner-leaf bottom-right" />
    </>
  );
};
